/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 * Notification Constants
 *
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.0.0
 */

export const CHANGE_STATUS_NOTIFICATION =
  '@@b2b_portal_ui/notification/CHANGE_STATUS_NOTIFICATION';
export const CLOSE_NOTIFICATION =
  '@@b2b_portal_ui/notification/CLOSE_NOTIFICATION';
export const GET_NOTIFICATIONS_FAILED =
  '@@b2b_portal_ui/notification/GET_NOTIFICATIONS_FAILED';
export const GET_NOTIFICATIONS_START =
  '@@b2b_portal_ui/notification/GET_NOTIFICATIONS_START';
export const OPEN_NOTIFICATION =
  '@@b2b_portal_ui/notification/OPEN_NOTIFICATION';
